// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"49a5bb7f","301":"63215d44","384":"d94bccfe","970":"89818c93"}[chunkId] + ".chunk.js";
};